import React, { useEffect, useState } from "react";

// JS Files

// Others File

const Status = (props) => {
  const [status, setStatus] = useState(props.status.status);
  return (
    <>
      <p className="font-bold text-base md:text-lg text-mygray-700 text-justify">
        وضعیت پرونده شما:{" "}
        {status == "pending" ? (
          <span className="text-myblue-400 text-sm md:text-base">
            پرونده شما در حال بررسی است، از شکیبایی شما متشکریم.
          </span>
        ) : status == "accept" ? (
          <span className="text-mygreen-100 text-sm md:text-base">
            درخواست ثبت‌نام بیمه درمان تکمیلی برای بیمه‌شده اصلی و افراد تحت
            تکفل مورد تایید قرار گرفته است.
          </span>
        ) : status == "reject" ? (
          <span className="text-mygreen-100 text-sm md:text-base">
            درخواست ثبت‌نام بیمه درمان تکمیلی برای بیمه‌شده اصلی و افراد تحت
            تکفل مورد تایید قرار نگرفته است.
          </span>
        ) : (
          <span className="text-myred-400 text-sm md:text-base"></span>
        )}
      </p>

      {status == "reject" ? (
        <>
          <p className="font-bold mt-4 text-mygray-700">دلیل رد:</p>
          <p className="text-mygray-700 mt-2 text-justify text-sm md:text-base">
            {props.status.reject_description}
          </p>{" "}
        </>
      ) : (
        ""
      )}
    </>
  );
};
export default Status;
